import { UserProfileRole } from '@@types/api.types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetCurrentUser } from '../queries/users.query';
import { routes } from '../routes';

type UseRequireAdminParams = {
  onRedirect?: () => void;
  redirectTo?: string;
};

export const useRequireAdmin = (params?: UseRequireAdminParams) => {
  const options = params ?? {};
  const { onRedirect, redirectTo = routes.home.path } = options;

  const navigate = useNavigate();
  const { data: user, isPending } = useGetCurrentUser();

  const isAdmin = user?.profile?.role === UserProfileRole.ADMIN;

  useEffect(() => {
    if (!isPending && !isAdmin) {
      navigate(redirectTo, { replace: true });
      onRedirect?.();
    }
  }, [isPending, navigate, onRedirect, redirectTo, isAdmin]);

  return {
    isAdmin,
    isPending,
    user,
  };
};
